import { CardTemplateProps } from 'medere-ui-framework'
import { useMemo } from 'react'
import { ServiceListItemDTO } from '../../../dto/services/ServicesDTO'
import LocationActionMenu, { LocationActionItem } from '../../Location/tabs/components/LocationActionMenu'

export interface ServicesCardActionsProps {
  onEdit: (item: ServiceListItemDTO) => void
  onDelete: (item: ServiceListItemDTO) => void
}

type ServicesListCardProps = CardTemplateProps & ServicesCardActionsProps & {
  entity: ServiceListItemDTO
}

function normalizeValue(value: string | null | undefined, emptyText = 'Sin datos') {
  const normalizedValue = String(value ?? '').trim()
  return normalizedValue !== '' ? normalizedValue : emptyText
}

export default function ServicesListCard({
  entity,
  onEdit,
  onDelete,
}: Readonly<ServicesListCardProps>) {
  const cardMenuItems: LocationActionItem[] = useMemo(() => [
    {
      label: 'Editar',
      icon: 'pi pi-file-edit',
      action: () => onEdit(entity),
    },
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: () => onDelete(entity),
    },
  ], [entity, onDelete, onEdit])

  return (
    <article className='services-mobile-card'>
      <div className='services-mobile-card-header'>
        <h3 className='services-mobile-card-title'>{normalizeValue(entity.serviceName, 'Sin nombre')}</h3>
        <LocationActionMenu
          items={cardMenuItems}
          buttonClassName='p-button-text services-mobile-card-menu-btn'
          ariaLabel='Opciones del servicio'
          panelClassName='services-action-menu-panel'
          contentClassName='w-64'
        />
      </div>

      <div className='services-mobile-card-body'>
        <div className='services-mobile-card-row'>
          <span className='services-mobile-card-key'>Código externo</span>
          <span className='services-mobile-card-value'>{normalizeValue(entity.externalCode)}</span>
        </div>
        <div className='services-mobile-card-row'>
          <span className='services-mobile-card-key'>Jefe de servicio</span>
          <span className='services-mobile-card-value'>{normalizeValue(entity.currentBossName)}</span>
        </div>
        <div className='services-mobile-card-row'>
          <span className='services-mobile-card-key'>Estado</span>
          <span className='services-mobile-card-value'>{entity.active ? 'Activo' : 'Inactivo'}</span>
        </div>
      </div>
    </article>
  )
}
